import { render, staticRenderFns } from "./InventoryStateSwitchConfig.vue?vue&type=template&id=19ff25b9&scoped=true"
import script from "./InventoryStateSwitchConfig.vue?vue&type=script&lang=js"
export * from "./InventoryStateSwitchConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ff25b9",
  null
  
)

export default component.exports